import mapValues from 'lodash/mapValues';
import {generateError, errors} from 'privates/validations/errors';

let _RMI;
let _RGI;
let _wixSelector;
let _staticEventHandlers = {};
let _linkUtils;
let _backgroundUtils;
let _videoUrlsUtils;
let _repeaterUtils;
let _typeUtils;
let _componentsHooks;
let _uriUtils;
let _widgetUtils;
let _richTextUtils;
let _contextId;

const initGlobals = (platformUtils) => {
    _RGI = platformUtils.RGI;
};

const init = (platformUtils, wixSelector, onUpdateCallback) => {
    platformUtils.RMI.setUpdateCallback(onUpdateCallback);
    _RMI = platformUtils.RMI;
    _linkUtils = platformUtils.linkUtils;
    _backgroundUtils = platformUtils.backgroundUtils;
    _videoUrlsUtils = platformUtils.videoUrlsUtils;
    _repeaterUtils = platformUtils.repeaterUtils;
    _typeUtils = platformUtils.typeUtils;
    _componentsHooks = platformUtils.componentsHooks;
    _uriUtils = platformUtils.uriUtils;
    _widgetUtils = platformUtils.widgetUtils;
    _richTextUtils = platformUtils.richTextUtils;
    _wixSelector = wixSelector;
};

const setStaticEventHandlers = (eventHandlers, contextId) => {
    _staticEventHandlers = mapValues(eventHandlers, (callback) => ({contextId, controllerId: contextId, callback}));
};

const setContextId = (contextId) => {
    _contextId = contextId;
};

const throwIfMissing = (param, apiName) => {
    if (!param){
        const errorMessage = apiName ? generateError.error_api_with_name_before_page_ready({apiName}) : errors.ERROR_API_BEFORE_PAGE_READY;
        throw new Error(errorMessage);
    }
    return param;
};

const getStaticEventHandler = (name, onlyCallback) => {
    const staticEventHandler = _staticEventHandlers[name]; // TODO - backward compatibility - remove after worker next release
    if(!staticEventHandler){
        return null;
    } else if(onlyCallback){
        return staticEventHandler.callback;
    }

    return staticEventHandler;
};

const getRMI = (apiName) => throwIfMissing(_RMI, apiName);

const getRGI = () => _RGI;

const getWixSelector = (apiName) => throwIfMissing(_wixSelector, apiName);

const getLinkUtils = () => _linkUtils;

const getBackgroundUtils = () => _backgroundUtils;

const getVideoUrlUtils = () => _videoUrlsUtils;

const getRepeaterUtils = () => _repeaterUtils;

const getTypeUtils = () => _typeUtils;

const getComponentsHooks = () => _componentsHooks;

const getUriUtils = () => _uriUtils;

const getWidgetUtils = () => _widgetUtils;

const getRichTextUtils = () => _richTextUtils;

const getContextId = () => _contextId;

module.exports = {
    initGlobals,
    init,
    getWixSelector,
    setStaticEventHandlers,
    setContextId,
    getRMI,
    getRGI,
    getLinkUtils,
    getStaticEventHandler,
    getVideoUrlUtils,
    getTypeUtils,
    getRepeaterUtils,
    getBackgroundUtils,
    getComponentsHooks,
    getUriUtils,
    getWidgetUtils,
    getRichTextUtils,
    getContextId
};



// WEBPACK FOOTER //
// ./js/modules/privates/platformUtils.es6